<div class="container-slider-service" *ngFor="let service of services">
  <app-home-service-item [service]="service"></app-home-service-item>
</div>